import React from "react";
import { Table } from "react-bootstrap";
import "../../../assets/styles/scheduledChanges.scss";

const ScheduledChangeDetailUpdates = ({ changeDetailsJson }) => {
  const parsedChangeDetails = React.useMemo(() => {
    if (!changeDetailsJson) return null;

    if (typeof changeDetailsJson === "object") {
      return changeDetailsJson;
    }

    try {
      return JSON.parse(String(changeDetailsJson));
    } catch {
      return null;
    }
  }, [changeDetailsJson]);

  const updatesRows = React.useMemo(() => {
    const updates = parsedChangeDetails?.Updates ?? parsedChangeDetails?.updates;

    if (Array.isArray(updates)) {
      return updates.filter((item) => item && typeof item === "object");
    }

    if (updates && typeof updates === "object") {
      return [updates];
    }

    return [];
  }, [parsedChangeDetails]);

  const orderedUpdateEntries = React.useMemo(() => {
    const preferredOrder = ["Column", "Value", "OldValue", "NewValue"];

    return updatesRows.map((row) => {
      const keys = Object.keys(row).filter(
        (key) => String(key).toLowerCase() !== "updateddate",
      );
      const orderedKeys = [
        ...preferredOrder.filter((key) => keys.includes(key)),
        ...keys.filter((key) => !preferredOrder.includes(key)),
      ];

      return orderedKeys.map((key) => [key, row[key]]);
    });
  }, [updatesRows]);

  const renderPrimitive = (value) => {
    if (value === null || value === undefined || value === "") return "-";
    if (typeof value === "object") return JSON.stringify(value);
    return String(value);
  };

  return (
    <div className="sc-detail-table-shell sc-detail-table-shell--updates">
      <h5 className="sc-detail-table__section-title sc-detail-table__section-title--updates">
        Edytowane dane
      </h5>

      <Table size="sm" className="sc-detail-table mb-0" responsive>
        <tbody>
          {orderedUpdateEntries.length === 0 ? (
            <tr>
              <td className="sc-detail-table__value">Brak danych w Updates.</td>
            </tr>
          ) : (
            <>
              {orderedUpdateEntries.map((entries, rowIndex) => (
                <React.Fragment key={`update-${rowIndex}`}>
                  {entries.map(([key, value]) => (
                    <tr key={`update-${rowIndex}-${key}`}>
                      <td className="sc-detail-table__label">{key}</td>
                      <td className="sc-detail-table__value">
                        <span className="sc-detail-table__text">{renderPrimitive(value)}</span>
                      </td>
                    </tr>
                  ))}
                  {rowIndex < orderedUpdateEntries.length - 1 && (
                    <tr className="sc-detail-table__record-spacer" aria-hidden="true">
                      <td colSpan={2}></td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </>
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default ScheduledChangeDetailUpdates;
